export default  {
  mounted() {
    window.addEventListener('resize', this.isMobileCheck);

    this.isMobileCheck();
  },
  data() {
    return {
      isMobile: null
    }
  },
  methods: {
    isMobileCheck() {
      if(window.innerWidth < 1024) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

    },
  }
};




// WEBPACK FOOTER //
// ./src/plugins/isMobileMixin.js